var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisbursed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 8,
    fill: "#16A02C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29102 4.41602H8.43022C8.51935 4.41602 8.63819 4.42026 8.78675 4.42875C8.93955 4.43299 9.07537 4.44573 9.19422 4.46695C9.74175 4.55184 10.1895 4.73223 10.5376 5.00812C10.8899 5.284 11.1488 5.63205 11.3143 6.05225C11.4798 6.4682 11.5626 6.93297 11.5626 7.44655C11.5626 8.21479 11.3822 8.85995 11.0214 9.38202C10.6607 9.89984 10.1068 10.2373 9.35975 10.3943C9.17724 10.4325 9.02444 10.4559 8.90135 10.4643C8.77826 10.4728 8.62122 10.4771 8.43022 10.4771H6.29102V8.85995H8.35382C8.44295 8.85995 8.54057 8.8557 8.64668 8.84722C8.75279 8.83873 8.85042 8.82175 8.93955 8.79628C9.17299 8.72837 9.35338 8.62014 9.48072 8.47158C9.60805 8.32303 9.69506 8.15749 9.74175 7.97498C9.79268 7.78823 9.81815 7.61208 9.81815 7.44655C9.81815 7.28102 9.79268 7.10699 9.74175 6.92448C9.69506 6.73773 9.60805 6.57007 9.48072 6.42152C9.35338 6.26872 9.17299 6.16048 8.93955 6.09682C8.85042 6.07135 8.75279 6.05437 8.64668 6.04588C8.54057 6.03739 8.44295 6.03315 8.35382 6.03315H6.29102V4.41602ZM6.29102 10.4771L8.20102 10.0823L12.1356 13.584H9.72902L6.29102 10.4771ZM6.34195 8.08958V6.80352H12.7086V8.08958H6.34195ZM8.20102 5.70208V4.41602H12.6577V5.70208H8.20102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbursed);
export default __webpack_public_path__ + "static/media/disbursed.89369098b76c8e52f915ea9b54101859.svg";
export { ForwardRef as ReactComponent };